/* eslint-disable */
import COS from "cos-js-sdk-v5";

import { fetchGetProblemsToken } from "../api/submission";

export function getProblemFileCOS(token: string, contestId: number, trackId: number, stageId: number, problemId: number) {
  return new COS({
    getAuthorization: (options, callback) => {
      fetchGetProblemsToken(token, contestId, trackId, stageId, problemId).then(
        (data) => {
          const credentials = data && data.credentials;
          if (!data || !credentials) {
            return console.error("credentials invalid");
          }
          //console.log(data);
          callback({
            TmpSecretId: credentials.tmpSecretId,
            TmpSecretKey: credentials.tmpSecretKey,
            XCosSecurityToken: credentials.sessionToken,
            StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
            ExpiredTime: data.expiredTime, // 时间戳，单位秒，如：1580000900
          });
        }
      );
    },
  });
}
